import TabVariantsDemo from "../lib/components/TopTabBar/TabVariantsDemo";

const TabDemo = () => {
  return <TabVariantsDemo />;
};

export default TabDemo;
